<!-- <h1 class="text-center">{{ pageTitle }}</h1> -->

<div class="jumbotron jumbotron-fluid">
  <div class="columns">
    <div class="column1">
      <img  src="../../assets/images/mean-logo2.png">
    </div>
    <div class="home-column">
      <h1 class="title">MEAN Stack Contact List</h1>
      <h2 class="subtitle">W/ A Node.js RESTful API, Mock Data & Auth0</h2>
    </div>
  </div>
</div>
